import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Modal } from '@efast_public/fjd-component-library';
import './global.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

Modal.setAppElement('#app');

const container = document.getElementById('app');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
